import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import api, { errMsg } from "../lib/api";
import { AuthShell } from "./ForgotPassword";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [valid, setValid] = useState(null);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  useEffect(() => {
    if (token.length < 20) { setValid(false); return; }
    api.post("/auth/reset-password/verify", { token }).then((r) => setValid(r.data.valid)).catch(() => setValid(false));
  }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return setErr("Password must be at least 8 characters");
    if (pw !== pw2) return setErr("Passwords do not match");
    setBusy(true); setErr("");
    try { await api.post("/auth/reset-password", { token, new_password: pw }); setDone(true); }
    catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };
  if (done) return (
    <AuthShell title="Password updated">
      <div className="flex gap-3 text-sm text-emerald-700 bg-emerald-50 rounded-lg p-3" data-testid="reset-success"><CheckCircle2 className="h-5 w-5" />Your password has been changed. All other sessions were signed out.</div>
    </AuthShell>
  );
  return (
    <AuthShell title="Choose a new password">
      {valid === null ? <Loader2 className="h-5 w-5 animate-spin text-primary" /> : !valid ? (
        <div className="text-sm text-rose-700 bg-rose-50 rounded-lg p-3" data-testid="reset-invalid">This reset link is invalid, already used or expired. <Link to="/forgot-password" className="font-semibold underline">Request a new link</Link>.</div>
      ) : (
        <form onSubmit={submit} className="space-y-3">
          <input type="password" className="vmw-input" placeholder="New password (min 8 characters)" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password" />
          <input type="password" className="vmw-input" placeholder="Confirm new password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm" />
          {err && <p className="text-sm text-rose-600" data-testid="reset-error">{err}</p>}
          <button className="vmw-gradient text-white w-full h-10 rounded-lg font-semibold inline-flex items-center justify-center gap-2" disabled={busy} data-testid="reset-submit">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}Update password</button>
        </form>
      )}
    </AuthShell>
  );
}
